import React, { useState } from 'react';
//import './Profile.css';

function Profile() {
    const [mode, setMode] = useState('admin');
    const [email, setEmail] = useState('user@example.com');
    const [roles, setRoles] = useState([
        { name: 'Model', active: true },
        { name: 'Talent', active: false },
        { name: 'Admin', active: true },
        { name: 'Photographer', active: false },
        { name: 'Stylist', active: true }
    ]);

    const [groups, setGroups] = useState([
        { name: 'Models Booker', active: false },
        { name: 'Scout', active: true },
        { name: 'Fashion Week Bookers', active: false }
    ]);

    const [isModalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState('');
    const [newName, setNewName] = useState('');
    const [isDropdownOpen, setDropdownOpen] = useState(false); 
    const [address, setAddress] = useState('123 Main St, City, Country');
    const [phone, setPhone] = useState('+123 456 7890');
    const [tempAddress, setTempAddress] = useState(address); // Temporary state for editing
    const [tempPhone, setTempPhone] = useState(phone);

    const openModal = (type) => {
        setModalOpen(true);
        setModalType(type);
    };

    const closeModal = () => {
        setModalOpen(false);
        setNewName('');
    };

    const handleCreate = () => {
        if (modalType === 'role') {
            setRoles([...roles, { name: newName, active: false }]);
        } else if (modalType === 'group') {
            setGroups([...groups, { name: newName, active: false }]);
        }
        closeModal();
    };

    const toggleMode = () => {
        setMode((prevMode) => (prevMode === 'admin' ? 'user' : 'admin'));
    };

    const toggleActive = (type, index) => {
        if (mode !== 'admin') return;
        if (type === 'roles') {
            setRoles(prevRoles =>
                prevRoles.map((role, i) =>
                    i === index ? { ...role, active: !role.active } : role
                )
            );
        } else if (type === 'groups') {
            setGroups(prevGroups =>
                prevGroups.map((group, i) =>
                    i === index ? { ...group, active: !group.active } : group
                )
            );
        }
    };

    const filteredRoles = mode === 'admin' ? roles : roles.filter(role => role.active);
    const filteredGroups = mode === 'admin' ? groups : groups.filter(group => group.active);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const applyChanges = () => {
        console.log("Email applied:", email);
    };

    const toggleDropdown = () => {
        setDropdownOpen(prevState => !prevState);
    };

    // Apply or cancel changes to address and phone
    const applyAddressPhoneChanges = () => {
        setAddress(tempAddress);
        setPhone(tempPhone);
    };

    const cancelAddressPhoneChanges = () => {
        setTempAddress(address);
        setTempPhone(phone);
    };

    return (
        <div className="profile-container">
            <div className="sidebar">
                <ul>
                    <li>Profile</li>
                    <li>Help & Support</li>
                    {mode === 'admin' && <li>User List</li>}
                </ul>
            </div>
            <div className="content">
                <div className="email-password-roles-groups">
                    <div className="email-password-container">
                        <div className="email-section">
                            <h3>Contact Email</h3>
                            <input
                                type="email"
                                value={email}
                                onChange={handleEmailChange}
                                disabled={mode !== 'admin'}
                            />
                            {mode === 'admin' && (
                                <button onClick={applyChanges} className="apply-button">
                                    Apply
                                </button>
                            )}
                        </div>
                        <div className="password-section">
                            <h3>Update Password</h3>
                            <input type="password" placeholder="Enter New Password" />
                            <input type="password" placeholder="Confirm New Password" />
                            <button>Update Password</button>
                        </div>
                    </div>
                    <div className="roles-groups-container">
                        <div className="roles-section">
                            <h3>Roles</h3>
                            <div className="roles-list">
                                {filteredRoles.map((role, index) => (
                                    <div key={role.name} className="role-item">
                                        <span>{role.name}</span>
                                        {mode === 'admin' && (
                                            <button
                                                className={`toggle-button ${role.active ? 'active' : ''}`}
                                                onClick={() => toggleActive('roles', index)}
                                            >
                                                {role.active ? '✓' : '✗'}
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                            {mode === 'admin' && (
                                <button className="add-button" onClick={() => openModal('role')}>
                                    Add Role
                                </button>
                            )}
                        </div>
                        <div className="groups-section">
                            <h3>Groups</h3>
                            <div className="groups-list">
                                {filteredGroups.map((group, index) => (
                                    <div key={group.name} className="group-item">
                                        <span>{group.name}</span>
                                        {mode === 'admin' && (
                                            <button
                                                className={`toggle-button ${group.active ? 'active' : ''}`}
                                                onClick={() => toggleActive('groups', index)}
                                            >
                                                {group.active ? '✓' : '✗'}
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                            {mode === 'admin' && (
                                <button className="add-button" onClick={() => openModal('group')}>
                                    Add Group
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <button onClick={toggleMode} className="mode-toggle-button">
                    Switch to {mode === 'admin' ? 'User' : 'Admin'} Mode
                </button>
            </div>

            {/* Dropdown for Address and Phone Number at the bottom */}
            <div className={`dropdown-container ${isDropdownOpen ? 'open' : ''}`}>
                <button onClick={toggleDropdown} className="dropdown-button">
                    {isDropdownOpen ? 'Hide Details' : 'USER DETAILS'}
                </button>
                {isDropdownOpen && (
                    <div className="dropdown-content">
                        <div>
                            <label>
                                <strong>Address:</strong>
                            </label>
                            <input
                                type="text"
                                value={tempAddress}
                                onChange={(e) => setTempAddress(e.target.value)}
                                disabled={mode !== 'admin'}
                            />
                        </div>
                        <div>
                            <label>
                                <strong>Phone Number:</strong>
                            </label>
                            <input
                                type="text"
                                value={tempPhone}
                                onChange={(e) => setTempPhone(e.target.value)}
                                disabled={mode !== 'admin'}
                            />
                        </div>
                        {mode === 'admin' && (
                            <div className="dropdown-buttons">
                                <button onClick={applyAddressPhoneChanges} className="apply-button">
                                    Apply
                                </button>
                                <button onClick={cancelAddressPhoneChanges} className="cancel-button">
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>Add New {modalType === 'role' ? 'Role' : 'Group'}</h3>
                        <input
                            type="text"
                            placeholder={`Enter ${modalType === 'role' ? 'role' : 'group'} name`}
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                        />
                        <button onClick={handleCreate} className="create-button">
                            Create
                        </button>
                        <button onClick={closeModal} className="close-button">
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Profile;
